import { render, staticRenderFns } from "./BigButton.vue?vue&type=template&id=0a1036d6&scoped=true&"
import script from "./BigButton.vue?vue&type=script&lang=js&"
export * from "./BigButton.vue?vue&type=script&lang=js&"
import style0 from "./BigButton.vue?vue&type=style&index=0&id=0a1036d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1036d6",
  null
  
)

export default component.exports